/**
 * Booking validators
 */
import { z } from 'zod';
import { TimeSlot } from '../types/enums.js';
export const timeSlotSchema = z.enum([TimeSlot.MORNING, TimeSlot.AFTERNOON, TimeSlot.EVENING]);
export const cartItemSchema = z.object({
    tour_stop_id: z.string().uuid('Invalid tour stop ID'),
    class_option_id: z.string().uuid('Invalid class option ID'),
    scheduled_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Date must be YYYY-MM-DD format'),
    time_slot: timeSlotSchema,
    participant_count: z.number().int().min(1, 'Must have at least 1 participant').max(100),
    participant_level: z.string().max(100).optional(),
    special_requests: z.string().max(1000).optional(),
});
export const createBookingSchema = z.object({
    items: z.array(cartItemSchema).min(1, 'At least one class is required'),
    include_marketing_materials: z.boolean().default(false),
    terms_accepted: z.literal(true, {
        errorMap: () => ({ message: 'You must accept the terms and conditions' }),
    }),
});
export const updateBookingSchema = z.object({
    participant_count: z.number().int().min(1).max(100).optional(),
    participant_level: z.string().max(100).optional(),
    special_requests: z.string().max(1000).optional(),
    scheduled_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
    time_slot: timeSlotSchema.optional(),
});
//# sourceMappingURL=booking.js.map